import { Icon } from "@mui/material";
import Dashboard from "./dashboards/default";
import Accounts from './Accounts'
import AccountDetail from './Accounts/AccountDetail'
import Users from './Users'
import UiPrompts from './UiPrompts'

import Settings from "./settings";
import Saas from "./Saas";
import SaasAccounts from "./Saas/components/accounts"
import Assistants from "./Assistants";
import AgentFramework from "./AgentFramework";
import IframedApp from "./IframedApp";
import CouponHistory from "./Saas/components/coupon/CouponHistory";
// Home
// Dashboard
// SAAS
// Accounts
// Branding
// Users
// Library
// Settings
// Profile
// Billing
// Wallet
// Integration
function useRoutes() {
  return [
    {
      type: "collapse",
      name: "Home",
      key: "Home",
      icon: <Icon fontSize="small">home</Icon>,
      route: "/Home",
      component: <Dashboard />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: "/dashboard",
      component: <Dashboard />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "SAAS",
      key: "saas",
      icon: <Icon fontSize="small">highlight_alt</Icon>,
      route: "/saas",
      component: <Saas />,
      noCollapse: true,
    },
    {
      type: "collapse",
      key: "saas",
      route: "/saas/:product_id/accounts",
      component: <SaasAccounts />,
    },
    {
      type: "collapse",
      key: "coupon-history",
      route: "/saas/coupons/:promoCodeId/history",
      component: <CouponHistory />,
    },
    {
      type: "collapse",
      name: "Accounts",
      key: "accounts",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/accounts",
      component: <Accounts />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "account-detail",
      key: "account-detail",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/account-detail/:id", // Corrected route definition
      component: <AccountDetail />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "Users",
      key: "users",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/users",
      component: <Users />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "Library",
      key: "library",
      icon: <Icon fontSize="small">bookmarks</Icon>,
      route: "/library/*",
      component: <UiPrompts />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "Settings",
      key: "settings",
      icon: <Icon fontSize="small">settings</Icon>,
      route: "/settings/*",
      component: <Settings />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "assistants",
      key: "assistants",
      icon: <Icon fontSize="small">assistants</Icon>,
      route: "/assistants",
      component: <Assistants />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "agent-framework",
      key: "agent-framework",
      icon: <Icon fontSize="small">assistants</Icon>,
      route: "/agent-framework",
      component: <AgentFramework />,
      noCollapse: true,
    },
    {
      type: 'collapse',
      key: 'app_sso',
      route: '/iframe',
      component: <IframedApp />,
    },
  ];
}

export default useRoutes;
